import { render, staticRenderFns } from "./CheckModule.vue?vue&type=template&id=3495a28b&scoped=true"
import script from "./CheckModule.vue?vue&type=script&lang=js"
export * from "./CheckModule.vue?vue&type=script&lang=js"
import style0 from "./CheckModule.vue?vue&type=style&index=0&id=3495a28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495a28b",
  null
  
)

export default component.exports